import React, { useState } from 'react'
import {connect} from 'react-redux'
import { Layout, Menu, Image } from 'antd';
import { Link } from 'react-router-dom';
import {
  HomeOutlined,
  PieChartOutlined,
  BankOutlined,
  UserOutlined,
  TeamOutlined,
  LockOutlined,
  BookOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';

import {  userLogout } from './../actions/user'

const { Sider } = Layout;
const { SubMenu } = Menu;
function SideBar(props){
    const [collapsed, setCollapsed] = useState(true)
    const onCollapse = () => {
    setCollapsed(prev=>!prev);
    };
    return (
        <Sider trigger={null} className="no-print" collapsible collapsed={props.collapsed} onCollapse={()=>props.onCollapse()}>
          <div className="logo text-center mt-5 pt-10" >
              <Image
                width={80}
                height={100}
                alt="profile pictures"
                src={process.env.REACT_APP_SERVER_URL+ props.user.user.photo} 
                onError={(e)=>{
                e.target.onerror=null; 
                e.target.src=process.env.PUBLIC_URL+'/asset/img/defaultlogo.png'
                }}
              />
          </div>
          <Menu theme="dark" defaultSelectedKeys={['1']} mode="inline">
          <Menu.Item key="12" icon={<HomeOutlined />}>
            <Link to="/home/">Home</Link>
            </Menu.Item>
            <Menu.Item key="1" icon={<UserOutlined />}>
            <Link to="/home/profile">Profile</Link>
            </Menu.Item>
            <Menu.Item key="2" icon={<BankOutlined />}>
            <Link to="/home/index">School</Link>
            </Menu.Item>
            <SubMenu key="sub2" icon={<PieChartOutlined />} title="Reports">
              <Menu.Item key="3"><Link to="/home/report">Academic</Link></Menu.Item>
              <Menu.Item key="4"><Link to="/home/fee">Fees</Link></Menu.Item>
              <Menu.Item key="5"><Link to="/home/attendance">Attendance</Link></Menu.Item>
              <Menu.Item key="6"><Link to="/home/behaviora">Commendations</Link></Menu.Item>
              <Menu.Item key="7"><Link to="/home/behaviorb">Misbehaviors</Link></Menu.Item>
            </SubMenu>
            <SubMenu key="sub0" icon={<BookOutlined />} title="LMS">
              <Menu.Item key="8"><Link to="/home/subject">Lesson Management</Link></Menu.Item>
              <Menu.Item key="9"><Link to="/home/subject">CBT</Link></Menu.Item>
            </SubMenu>
            <Menu.Item key="10" icon={<InfoCircleOutlined />}>
            <Link to="/home/feedback">Feedback</Link>
            </Menu.Item>
            <Menu.Item key="11" icon={<LockOutlined />} onClick={()=>props.userLogout()}>
              Log Out
            </Menu.Item>
          </Menu>
        </Sider>    
    )
}

const mapStateToProps = (state) => ({
  user:state.userReducer,
  school:state.schoolReducer
})

const mapDispatchToProps = {
  userLogout
}

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)


